import { useEffect } from 'react';
import { toast } from 'sonner';
import type { TsoConfig } from 'src/apis/direct-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';
import {
  ApiVersions,
  useSupportsApiVersion,
} from 'src/hooks/use-direct-fcfs-flags';
import { isVerificationProblemWithoutField } from 'src/utils/is-verification-problem-without-field';

const tsoConfigApiUrl = PRISMA_CONFIG.directFcfs + '/tso-config';

export function useTsoConfig() {
  const apiVersionCheck = useSupportsApiVersion();
  const request = useAxios(
    (axios, baseConfig) =>
      axios.request<TsoConfig>({
        ...baseConfig,
        url: tsoConfigApiUrl,
        method: 'GET',
      }),
    {
      neededOnPageLoad: true,
    }
  );

  const apiEnabled = apiVersionCheck(ApiVersions.V5_ONC_1608);
  useEffect(() => {
    if (!apiEnabled) return;
    request.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return apiEnabled ? request : undefined;
}

export type TsoConfigRequest = ReturnType<typeof useTsoConfig>;

export function useTsoConfigUpdate() {
  const request = useAxios(
    (axios, baseConfig, data: TsoConfig) =>
      axios.request<void>({
        ...baseConfig,
        url: tsoConfigApiUrl,
        method: 'POST',
        data,
      }),
    {
      neededOnPageLoad: false,
      onError(error) {
        const message = isVerificationProblemWithoutField(error)
          ? error.response.data.message
          : 'Unknown error during save';
        toast.error(message);
        return error;
      },
    }
  );

  return request;
}
